/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const ResolveIncidentHeaders = zod.object({
  'x-csrf-token': zod.string(),
});

export type ResolveIncidentHeaders = zod.input<typeof ResolveIncidentHeaders>;
export type ResolveIncidentHeadersOutput = zod.output<typeof ResolveIncidentHeaders>;
